export enum CreditorNumberType {
  NoDisplay = 0,
  DomainId = 1,
  ExternalRef = 2,
}
